module.exports = __webpack_public_path__ + "img/ZWF_Marta_Grabowska.549838dd.jpg";